export default __webpack_public_path__ + "static/MediaContentFour-b7be2b527614d2354b662500ad57fe3b.webp";